<img
  [src]="src || empty"
  [src-fallback]="empty"
  class="h-full w-full object-cover p-4"
  [ngClass]="class"
  [alt]="'geral.contents' | translate"
/>
